(() => {
  let brandLogoEl = document.querySelector(".brand-logo");

  async function getVariantBrandSection(variantId = null) {
    let url = "?sections=variant-brand-logo";

    if (variantId) {
      url = url + `&variant=${variantId}`;
    }

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const result = await response.json();
      setVariantBrandSection(result);
    } catch (error) {
      console.error(error.message);
    }
  }

  function setVariantBrandSection(sections) {
    let htmlString = sections["variant-brand-logo"];
    htmlString = htmlString.replace('<div id="shopify-section-variant-brand-logo" class="shopify-section">', '');
    htmlString = htmlString.replace('</div>', '');

    const div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    const newImg = div.firstChild;

    brandLogoEl.replaceWith(newImg);
    brandLogoEl = newImg;
  }

  document.addEventListener("variant-changed", (e) => {
    const variant = e.detail;
    if (brandLogoEl) {
      getVariantBrandSection(variant.id);
    }
  });

  class TruncatedDescription extends HTMLElement {
    constructor() {
      super();
      this._internals = this.attachInternals();
      this.controller = this.querySelector(".controller");
      this.description = this.querySelector(".collection__description");
      this.descriptionLast = this.description.lastChild;
    }

    connectedCallback() {
      this.controller.addEventListener("click", (e) => {
        this.open = !this.open;

        if (this.open)  {
          this.controller.textContent = "read less";

          // Move controller to inside the description
          if (this.descriptionLast.nodeType == 3) {
            this.descriptionLast.after(this.controller);
          } else {
            this.descriptionLast.append(this.controller);
          }
        } else {
          this.controller.textContent = "read more";

          // Move controller to outside the description
          this.description.after(this.controller); 
        }
      });
    }

    get open() {
      return this._internals.states.has("open");
    }

    set open(flag) {
      if (flag) {
        this._internals.states.add("open");
      } else {
        this._internals.states.delete("open");
      }
    }
  }

  customElements.define("truncated-description", TruncatedDescription);

  class ATLForm extends HTMLElement {
    constructor() {
      super();
      this._internals = this.attachInternals();

      this.form = this.querySelector("form");
      this.formAction = this.form.action;
      this.submitBtn = this.querySelector("form button[type=submit]");

      this.formMessage = this.querySelector(".form__message");
      this.formMessageUl = this.formMessage.querySelector(".form__message ul");

      this.recaptchaEl = this.querySelector(".recaptcha");

      this.recaptchaId;
    }

    get loading() {
      return this._internals.states.has("loading");
    }

    set loading(flag) {
      if (flag) {
        this._internals.states.add("loading");
      } else {
        this._internals.states.delete("loading");
      }
    }

    connectedCallback() {
      document.addEventListener("recaptchaLoaded", (e) => {
        this.setupRecaptcha();
      });

      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.loading = true;
        window.grecaptcha.execute(this.recaptchaId);
      });
    }

    setupRecaptcha() {
      this.recaptchaId = window.grecaptcha.render(this.recaptchaEl, {
        "callback": () => {
          this.sendData();
        }
      });
    }

    showMessage(message) {
      this.formMessage.classList.add("form__message--success");
      this.formMessage.classList.remove("form__message--error");
      this.formMessage.style.display = "block";

      this.formMessageUl.innerHTML = "";

      let li = document.createElement("li");
      li.innerHTML = message;
      this.formMessageUl.appendChild(li);
    }

    showErrors(errors) {
      this.formMessage.classList.add("form__message--error");
      this.formMessage.classList.remove("form__message--success");
      this.formMessage.style.display = "block";

      this.formMessageUl.innerHTML = "";

      let li;
      for (const err in errors) {
        li = document.createElement("li");
        li.innerHTML = errors[err];
        this.formMessageUl.appendChild(li);
      }

      this.formMessage.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    async sendData() {
      const formData = new FormData(this.form);
      
      const now = new Date();
      formData.append("date", now.toString());

      const formObj = Object.fromEntries(formData);
      const formJson = JSON.stringify(formObj);

      const hasFiles = this.form.enctype == 'multipart/form-data' ? true : false;

      const fetchOpts = {
        method: "POST",
        body: hasFiles ? formData : formJson
      }

      if (!hasFiles) {
        fetchOpts.headers = {
          "Content-Type": "application/json"
        }
      }

      try {
        const response = await fetch(this.formAction, fetchOpts);

        const result = await response.json();

        if (response.status === 400) {
          this.showErrors(result);
          this.submitBtn.disabled = false;
          this.loading = false;
          window.grecaptcha.reset(this.recaptchaId);
          return;
        }

        if (response.ok) {
          this.showMessage(result.message);
          this.loading = false;
          this.form.style.display = "none";
        }
      } catch (err) {
        console.error(err.message);
        this.loading = false;
      }
    }
  }

  customElements.define("atl-form", ATLForm); 

  class InfiniteScroll extends HTMLElement {
    constructor() {
      super();

      this.paginate = JSON.parse(
        this.querySelector('[type="application/json"]').textContent
      );

      this.productsList = document.getElementById("main-collection-products");
      this.productCountContainer = document.getElementById("collection-product-count");
    }

    connectedCallback() {
      this.infiniteScrollObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.getNextPage();
          });
        },
        {
          root: null,
          rootMargin: "0px 0px 200% 0px",
          threshold: 0,
        }
      );

      this.infiniteScrollObserver.observe(this);

      document.getElementById("CollectionProducts")?.addEventListener("renderProductGrid", (e) => {
        if (this.productCountContainer) {
          this.getProductCount();
        }
      });
    }

    async getProductCount() {
      const currentUrl = window.location.href;

      const url = new URL(currentUrl);
      url.searchParams.append("sections", "collection-product-count");

      const newUrl = url.toString();

      try {
        const response = await fetch(newUrl);

        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }

        const result = await response.json();
        const newCount = result["collection-product-count"];
        this.setNewProductCount(newCount);
      } catch (error) {
        console.error(error.message);
      }
    }

  setNewProductCount(newCountHtml) {
    const div = document.createElement("div");
    div.innerHTML = newCountHtml.trim();
    const newCount = div.querySelector(".collection-product-count");
    this.productCountContainer.innerHTML = newCount.innerHTML;
  }

    async getNextPage() {
      const nextUrl = this.paginate.next?.url;

      if (!nextUrl) {
        this.stopObserving();
        return;
      }

      let sectionId = null;
    
      if (nextUrl.startsWith("/collections")) {
        sectionId = "product-grid-items";
      } else if (nextUrl.startsWith("/search")) {
        sectionId = "search-results-grid-items";
      }

      if (!sectionId) {
        this.stopObserving();
        return;
      }

      const url = `${nextUrl}&sections=${sectionId}`;

      try {
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }

        const result = await response.json();
        const newProducts = result[sectionId];
        this.appendNewProducts(newProducts);
      } catch (error) {
        console.error(error.message);
      }
    }

    stopObserving() {
      this.infiniteScrollObserver.unobserve(this);
    }

    appendNewProducts(newProductsHtml) {
      const div = document.createElement('div');
      div.innerHTML = newProductsHtml.trim();

      const newItems = div.querySelectorAll(".shopify-section .grid-item");

      newItems.forEach(newItem => {
        this.productsList.append(newItem);
      });

      // Set the new "paginate" data
      this.paginate = JSON.parse(
        div.querySelector('[type="application/json"]').textContent
      );

      if (this.paginate.current_page == this.paginate.pages) {
        this.stopObserving();
      }
    }
  };

  customElements.define("infinite-scroll", InfiniteScroll);
})();